// extracted by mini-css-extract-plugin
export default {"container":"PlayerProfileWrapper_container__tc5TY"};